import React from 'react'

import { connect } from 'react-redux'
import { keys, max, get } from 'lodash'
import { Link } from 'react-router-dom'
import TrendChart from '../../components/TrendChart'
import DistributionChart from '../../components/DistributionChart'
import SunBurstChart from '../../components/SunBurstChart'
import StarChart from '../../components/StarChart'
import BubbleAndBarChart from '../../components/BubbleAndBarChart'
import { makeCancelable } from '../../utils'
import Spinner from '../../components/Spinner'
import { loadTfaArticles } from '../../state/actions'
import { Origin } from 'redux-tooltip'
import {
  thirdPillarMainTopic,
  thirdPillarTopics,
  sevenPillarsMainTopic,
  sevenPillarsTopics,
  countryFacilitationTopics,
  allTFAArticles,
} from '../../utils'
import './index.css'

const thirdPillarIndicators = [thirdPillarMainTopic].concat(thirdPillarTopics)
const sevenPillarsIndicators = [sevenPillarsMainTopic].concat(
  sevenPillarsTopics,
)

const DtHeader = () => (
  <div className="cf pa3">
    <div className="fl w-30">
      <h3 className="f3 lh-copy DataExplorer__table_heading">INDICATOR</h3>
    </div>
    <div className="fl w-25">
      <h3 className="f3 lh-copy DataExplorer__table_heading">DISTRIBUTION</h3>
    </div>
    <div className="fl w-25">
      <h3 className="f3 lh-copy DataExplorer__table_heading">TREND</h3>
    </div>
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading">SCORE</h3>
    </div>
  </div>
)

const DtHeaderTFA = () => (
  <div className="cf pa3">
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading">TFA ARTICLE</h3>
    </div>
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading tl">CATEGORY A</h3>
    </div>
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading tl">CATEGORY B</h3>
    </div>
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading tl">CATEGORY C</h3>
    </div>
    <div className="fl w-20">
      <h3 className="f3 lh-copy DataExplorer__table_heading tl">SCORE</h3>
    </div>
  </div>
)

const DtBody = ({
  indicatorsForCountry,
  countryData,
  indicators,
  countryCode,
  latestDataByIndicator,
  meta,
}) => (
  <div>
    {indicatorsForCountry.map(indicator => {
      //latest value
      const lastYear = max(keys(countryData[indicator]))
      if (!lastYear) {
        return null
      }
      const value = countryData[indicator][lastYear]['v']
      const m = countryData[indicator][lastYear]['m']

      return (
        <div className="cf pa3 bb border-blue" key={indicator}>
          <div className="fl w-30">
            <div className="DataExplorer__Block">
              <Origin
                content={
                  <div>
                    {indicators[indicator].titleWithUnits && (
                      <div>{indicators[indicator].titleWithUnits}</div>
                    )}
                    <div>
                      Rank direction:{' '}
                      {indicators[indicator].rankDirection === '0'
                        ? 'High is better'
                        : 'Low is better'}
                    </div>
                    {indicators[indicator].domain && (
                      <div>
                        Domain: {indicators[indicator].domain[0]} -{' '}
                        {indicators[indicator].domain[1]} <br />
                        {/* domain from meta: {indicators[indicator].fixed_domain ? 'True' : 'False'} */}
                      </div>
                    )}
                  </div>
                }
              >
                <Link
                  className="no-underline underline-hover text-blue"
                  to={`/topics/${indicator}`}
                >
                  {indicators[indicator].shortTitle ||
                    indicators[indicator].globalId}
                </Link>
              </Origin>
            </div>
          </div>
          <div className="fl w-25">
            <div className="ph2 w-75">
              <DistributionChart
                indicator={indicator}
                countryCode={countryCode}
                distributionData={latestDataByIndicator[indicator]}
                style={{ width: '100%' }}
              />
            </div>
          </div>
          <div className="fl w-25">
            <div className="ph2 w-75">
              <TrendChart
                showScores={false}
                indicatorData={indicators[indicator]}
                countryCode={countryCode}
                dataByCountry={countryData[indicator]}
              />
            </div>
          </div>
          <div className="fl w-20 cf">
            <div className="DataExplorer__Block cf">
              <div className="w-100">
                <div className="fl w-25 tl">
                  <span className="DataExplorer__Value">{value}</span>
                </div>
                <div className="fl w-75 tr">
                  <Origin
                    content={
                      <div style={{ maxWidth: '300' }}>
                        {get(meta, m, '')
                          .replace(/\|/g, ' | ')
                          .split(';')
                          .map(piece => (
                            <div key={piece}>{piece}</div>
                          ))}
                      </div>
                    }
                  >
                    MORE INFO
                  </Origin>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })}
  </div>
)

const DtBodyTFA = ({
  indicatorsForCountry,
  tfaArticles,
  tfaMeta,
  countryCode,
  latestDataByIndicator,
  meta,
}) => (
  <div>
    {indicatorsForCountry.map(indicator => {
      //latest value
      const value = get(tfaArticles[indicator], `[${countryCode}]['v']`, null)
      const valueA = get(tfaArticles[indicator], `[${countryCode}]['A']`, null)
      const valueB = get(tfaArticles[indicator], `[${countryCode}]['B']`, null)
      const valueC = get(tfaArticles[indicator], `[${countryCode}]['C']`, null)
      const { max } = tfaMeta[indicator]
      const getPercent = val => `${((100 * val) / max).toFixed(2)}%`

      if (value === null) {
        return null
      }

      return (
        <div className="cf pa3 bb border-blue" key={indicator}>
          <div className="fl w-20">
            <div className="DataExplorer__Block">
              <Origin
                content={
                  <div>
                    {`TFA Article ${indicator}`}
                    <div>
                      Domain: {'0'} - {tfaMeta[indicator].max} <br />
                    </div>
                  </div>
                }
              >
                <Link
                  className="no-underline underline-hover text-blue"
                  to={`//tfa/${indicator}`}
                >
                  {`TFA Article ${indicator}`}
                </Link>
              </Origin>
            </div>
          </div>
          <div className="fl w-20">
            <div className="DataExplorer__Block">
              <span className="DataExplorer__Value">{getPercent(valueA)}</span>
            </div>
          </div>

          <div className="fl w-20">
            <div className="DataExplorer__Block">
              <span className="DataExplorer__Value">{getPercent(valueB)}</span>
            </div>
          </div>

          <div className="fl w-20">
            <div className="DataExplorer__Block">
              <span className="DataExplorer__Value">{getPercent(valueC)}</span>
            </div>
          </div>

          <div className="fl w-20 cf">
            <div className="DataExplorer__Block">
              <div className="w-100">
                <div className="fl w-25 tl">
                  <span className="DataExplorer__Value">
                    {value.toFixed(2)}
                  </span>
                </div>
                <div className="fl w-75 tr">
                  <Origin
                    content={`Ratified on ${
                      tfaArticles[indicator][countryCode].date
                    }`}
                  >
                    MORE INFO
                  </Origin>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })}
  </div>
)

// Render all indicators is very expansive so slpit
// the render of table in a component \w fixed props as dependencies
// (remove router / transition stuff that trigegger useless re renders)
class IndicatorsTable extends React.PureComponent {
  state = {
    countryData: null,
    loading: true,
    latestDataByIndicator: require('../../data/latest_by_indicator.json'),
  }

  componentWillUnmount = () => {
    this.fetcher.cancel()
  }

  componentWillMount = () => {
    const { countryCode } = this.props
    const fileName = `/by_country/${countryCode.toLowerCase()}.json`
    this.fetcher = makeCancelable(fetch(fileName))

    this.fetcher.promise.then(response => {
      return response.json().then(data => {
        return this.setState({ countryData: data, loading: false })
      })
    })
  }

  render() {
    const { meta, indicators, countryCode, tfaArticles, tfaMeta } = this.props
    const { countryData, latestDataByIndicator, loading } = this.state
    const indicatorsForCountry = keys(countryData).sort()

    if (loading) {
      return <Spinner />
    }

    const passPropsSunBurst = {
      indicatorsForCountry: indicatorsForCountry.filter(
        i => thirdPillarIndicators.indexOf(i) !== -1,
      ),
      countryData,
      indicators,
      countryCode,
      latestDataByIndicator,
      meta,
    }

    const passPropsBubbles = {
      indicatorsForCountry: indicatorsForCountry.filter(
        i => sevenPillarsIndicators.indexOf(i) !== -1,
      ),
      countryData,
      indicators,
      countryCode,
      latestDataByIndicator,
      meta,
    }

    const passPropsStar = {
      indicatorsForCountry: indicatorsForCountry.filter(
        i => countryFacilitationTopics.indexOf(i) !== -1,
      ),
      countryData,
      indicators,
      countryCode,
      latestDataByIndicator,
      meta,
    }

    const passPropsStarTFA = {
      indicatorsForCountry: allTFAArticles,
      tfaArticles,
      tfaMeta,
      countryCode,
      latestDataByIndicator,
      meta,
    }

    const hasTfa = allTFAArticles.filter(a => tfaArticles[a][countryCode])

    return (
      <div>
        {/* previews */}
        <div>
          <div className="cf">
            <div className="w-50-l fl-l w-100">
              <div className="w-100 border-blue">
                <SunBurstChart
                  height={400}
                  showCountryLabel={false}
                  showDownloads={true}
                  latestDataByIndicator={latestDataByIndicator}
                  countryCode={countryCode}
                />
              </div>
            </div>
            <div className="w-50-l fl-l w-100 ph3">
              <h3 className="text-orange">
                Efficiency and transparency of border administration
              </h3>
              <p className="text-blue">
                The graph provides information about the 13 key indicators on
                the efficiency and transparency of border administration
                included in the Enabling Trade Index. The size of each ray
                reflects the performance of the economy on that indicator
                (longer rays indicate better performance)
              </p>
            </div>
          </div>
          <DtHeader />
          <DtBody {...passPropsSunBurst} />

          <div className="w-100">
            <div className="cf mt5">
              <div className="fl-l w-50-l w-100 DataExplorerCountry__Preview border-blue">
                <StarChart
                  height={400}
                  showCountryLabel={false}
                  showDownloads={true}
                  tfaArticles={tfaArticles}
                  latestDataByIndicator={latestDataByIndicator}
                  countryCode={countryCode}
                />
              </div>
              <div className="w-50-l fl-l w-100 ph3">
                <h3 className="text-orange">
                  Trade facilitation policies and TFA notifications
                </h3>
                <p className="text-blue">
                  The graph provides an overview of the trade facilitation
                  policies in the country through the lenses of OECD Trade
                  Facilitation Indicators (blue petals); and of its commitments
                  under the Trade Facilitation Agreement (red petals). OECD
                  indicators are based on a 0 (worst) to 2 (best) scale. Red
                  petals represent the share (0-100) of provisions of each
                  article of the TFA which have been notified under any of the
                  three categories (A, B and C).
                </p>
              </div>
            </div>
          </div>
          <DtHeader />
          <DtBody {...passPropsStar} />
          {hasTfa && (
            <div>
              <DtHeaderTFA />
              <DtBodyTFA {...passPropsStarTFA} />
            </div>
          )}

          <div className="w-100 pa3">
            <div className="cf mt5">
              <div className="fl-l w-50-l w-100 DataExplorerCountry__Preview border-blue">
                <BubbleAndBarChart
                  height={400}
                  showCountryLabel={false}
                  showDownloads={true}
                  latestDataByIndicator={latestDataByIndicator}
                  countryCode={countryCode}
                />
              </div>
              <div className="w-50-l fl-l w-100 ph3">
                <h3 className="text-orange">Enabling trade environment</h3>
                <p className="text-blue">
                  In the graph, the length of the blue shaded area reflects the
                  country’s performance in the overall Enabling Trade Index,
                  while the seven rays represent the seven underlying pillars.
                  The third pillar on the efficiency and transparency of border
                  administration is highlighted in orange.
                </p>
              </div>
            </div>
          </div>
        </div>
        <DtHeader />
        <DtBody {...passPropsBubbles} />
      </div>
    )
  }
}

class DataExplorerCountry extends React.PureComponent {
  componentWillMount() {
    this.props.loadTfaArticles()
  }

  render() {
    const {
      countries,
      indicators,
      meta,
      tfaArticles,
      tfaMeta,
      match,
    } = this.props
    const { countryCode } = match.params

    //if(!dataByCountry[countryCode]) { return null }

    //const countryData = dataByCountry[countryCode]

    return (
      <div>
        <h2 className="f3 lh-copy text-blue">{countries[countryCode]}</h2>
        <div className="pa1 cf">
          {/* intro text */}
          {/* <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p> */}

          {/* dropdown and download */}
          {/* <div>
              Dropdown here - Download here
            </div> */}

          {tfaArticles && (
            <div style={{ minHeight: 500 }}>
              <IndicatorsTable
                indicators={indicators}
                countryCode={countryCode}
                meta={meta}
                tfaArticles={tfaArticles}
                tfaMeta={tfaMeta}
                // countryData={countryData}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  meta: state.meta,
  tfaArticles: state.tfaArticles.data,
  tfaMeta: state.tfaMeta,
  //dataByCountry: state.dataByCountry,
})

const mapDispatchToProps = { loadTfaArticles }

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataExplorerCountry)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerCountry/index.js